export const DEFAULT_SCREENSHOT_DEVICE_ID = 'iPhone 8';

export const SCREENSHOT_DEVICE_IDS = [
  'iPhone SE',
  'iPhone 8',
  'iPhone 6',
  'iPhone 13',
  'iPhone 13 Pro Max',
  'Pixel 5',
  'Galaxy S8',
  'Galaxy S9+',
];
